export default __webpack_public_path__ + "static/media/pet-cat-default.9baf0110.svg";